"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var TrackEntry = /** @class */ (function (_super) {
    __extends(TrackEntry, _super);
    function TrackEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackEntry.prototype.componentDidMount = function () {
        var _a = this.props, track = _a.track, trackingMessage = _a.trackingMessage, _b = _a.trackingProps, trackingProps = _b === void 0 ? {} : _b;
        if (utils_1.isBrowser()) {
            var message = trackingMessage || 'track entry';
            track(message, __assign({}, trackingProps));
        }
    };
    TrackEntry.prototype.render = function () {
        return this.props.children;
    };
    return TrackEntry;
}(react_1.default.Component));
exports.default = TrackEntry;
